import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  absenceCalendar: 'month',
  allTicketsCustomerFilter: [],
  allTicketsOwnerFilter: [],
  allTicketsPriorityFilter: [],
  allTicketsSortColummnName: 'TicketID',
  allTicketsSortColumnDirection: 'desc',
  allTicketsStatusFilter: [],
  allTicketsTicketFilter: [],
  allTicketsRespondBreachedFilter: [],
  allTicketsResolveBreachedFilter: [],
  allTicketsTeamsFilter: [],
  allTicketsShowPool: false,
  // My Tickets MUI-Datatables
  myTicketsExpandedRowsState: [],
  myTicketsTicketFilter: [],
  myTicketsCustomerFilter: [],
  myTicketsOwnerFilter: [],
  myTicketsStatusFilter: [],
  myTicketsRespondBreachedFilter: [],
  myTicketsResolveBreachedFilter: [],
  myTicketsIncludeTreeData: false,
  //
  // LogsPage
  logsPageDaysBack: 1,
  myTimeAbsence: 'year',
  myTimeAbsenceRequests: 'year',
  myTimeChart: 'isoWeek',
  myTimeIncomingAbsenceRequests: 'year',
  myTimeServiceTime: 'isoWeek',
  myTimeStatistics: 'month',
  TeamBudgetStats: 'fiscalYear',
  myTimeWorkingTime: 'isoWeek',
  poolTicketsSortColummnName: 'TicketID',
  poolTicketsSortColumnDirection: 'desc',
  poolTicketsTicketFilter: [],
  poolTicketsRespondBreachedFilter: [],
  poolTicketsResolveBreachedFilter: [],
  theme: 'light',
  darkBackground: '#353535',
  darkCardBackground: '#424242',
  darkColumnBackground: '#383838',
  darkColumnBackgroundDrag: '#686868',
  lightBackground: '#f2f3f8',
  lightCardBackground: 'white',
  lightColumnBackground: '#ebecf0',
  lightColumnBackgroundDrag: '#f6c2a5',
  cmdbAccountRecID: '',
  cmdbSortColummnName: 'AssetName',
  cmdbSortColumnDirection: 'desc',
  cmdbCiTypeFilterRoot: ['Network Device', 'Server Computer'],
  cmdbCiTypeFilter: [],
  cmdbSiteFilter: [],
  cmdbAssetTypeFilter: [],
  cmdbStatusFilter: [],
  cmdbModelFilter: [],
  cmdbSortingState: [{ columnName: "AssetName", direction: "asc" }],
  cmdbGroupingState: [{ columnName: 'bs_type' }],
  cmdbHiddenColumnNames: [
    'RecID', 'monitoring_status_raw', 'PRTG_Device_Link',
    'PRTGDeviceID', 'MonitoringDeploymentStatus', 'monitoring_subdomain',
    'PRTG_Group_ID', 'monitoring_group_link', 'monitoring_maintenance_active',
    'monitoring_maintenance_start', 'monitoring_maintenance_end'
  ],
  // Project List
  projectsSortColummnName: 'CustomerName',
  projectsSortColumnDirection: 'desc',
  projectsSortingState: [{ columnName: "CustomerName", direction: "asc" }],
  projectsGroupingState: [],
  projectsHiddenColumnNames: ['RecID'],
  projectsFilteringState: [],
  // Team Planner
  teamPlannerSortColummnName: 'name',
  teamPlannerSortColumnDirection: 'desc',
  teamPlannerSortingState: [],
  teamPlannerGroupingState: [],
  teamPlannerHiddenColumnNames: ['rowId', 'parentRowId', 'link', 'type', 'member_count', 'customerName', 'startDate', 'golifeDate', 'description', 'opportunityId'],
  teamPlannerFilteringState: [],
  teamPlannerSelectedTeams: [],
  teamPlannerSelectedOpportunities: [],
  teamPlannerZoomLevel: 'week',
  teamPlannerAllocationUnit: 'hours',
  teamPlannerRowHeight: 47,
  teamPlannerRoleTeams: false,
  teamPlannerShowAllTeams: true,
  teamPlannerShowAllOpportunities: true,
  // Update Planner
  updatePlannerSortColummnName: 'AssetName',
  updatePlannerSortColumnDirection: 'desc',
  updatePlannerSelectedCustomers: [],
  updatePlannerShowAllCustomers: true,
  updatePlannerSelectedChangeOwners: [],
  updatePlannerShowAllChangeOwners: true,
  updatePlannerSelectedServicePackages: ['Service Operation'],
  updatePlannerShowAllServicePackages: false,
  updatePlannerSelectedAssetTypes: [],
  updatePlannerShowAllAssetTypes: true,
  updatePlannerHiddenColumnNames: ['id', 'parentId', 'rowType', 'SerialNumber', 'PrimaryIP', 'ServicePackageName', 'BusinessServiceCategoryName', 'PatchManagementRequired', 'PatchManagementChargeable', 'PatchManagementRemarks', 'PatchManagementWindow', 'PatchMonthJan', 'PatchMonthFeb', 'PatchMonthMar', 'PatchMonthApril', 'PatchMonthMay', 'PatchMonthJun', 'PatchMonthJul', 'PatchMonthAug', 'PatchMonthSep', 'PatchMonthOct', 'PatchMonthNov', 'PatchMonthDec', 'ServiceConfigurationName', 'ServiceConfigurationID'],
  updatePlannerFilteringState: [],
  updatePlannerRowHeight: 47,
  updatePlannerSortingState: [{ columnName: "AssetName", direction: "asc" }],
  // Finance Planner
  financePlannerSortColummnName: 'name',
  financePlannerSortColumnDirection: 'desc',
  financePlannerSortingState: [],
  financePlannerGroupingState: [],
  financePlannerHiddenColumnNames: ['rowId', 'parentRowId', 'probability', 'link', 'type', 'member_count', 'customerName', 'startDate', 'golifeDate', 'description', 'opportunityId', 'totalamount', 'otc_amount', 'mrc_amount', 'mrc_month_count', 'estimatedclosedate', 'ap_opportunityids', 'multiplier'],
  financePlannerFilteringState: [],
  financePlannerSelectedOpportunities: [],
  financePlannerSelectedProbabilities: [],
  financePlannerZoomLevel: 'month',
  financePlannerRowHeight: 47,
  financePlannerShowAllOpportunities: true,
  financePlannerShowAllProbabilities: true,
  financePlannerShowWeightedRevenue: false,
  financePlannerType: 'ALL',
  //updatePlannerGroupingState: [],
  // My Tickets DX Grid
  //myTicketsSortingState: [{ columnName: "CreatedDateTime", direction: "asc" }],
  // myTicketsGroupingState: [],
  // myTicketsExpandedRowIds: [],
  // myTicketsHiddenColumnNames: [
  //   'DateTimeResolved', 'DateTimeResponded', 'Link', 'NewJournals',
  //   'PlannedEndDate', 'RecID', 'ResolveBreached', 'ResolveBy_SLA',
  //   'RespondBreached', 'RespondBy_SLA', 'Watchlist', 'isGroupRow',
  //   'parentRowId', 'rowId'
  // ],
  // myTicketsFilteringState: [],
  // myTicketsRowHeight: 47,
  // Business Service
  bsCustomerFilter: [],
  bsCategoryFilter: [],
  bsSortColummnName: 'CustomerName',
  bsSortColumnDirection: 'asc',
  bsStatusFilter: [],
  bsTypeFilter: [],
  kanbanCardTypeFilter: [],
  kanbanUserFilter: [],
};

export const actionTypes = {
  UpdateFilter: "[UPDATE_FILTER] Action",
  ClearFilter: "[CLEAR_FILTER] Action",
};

export const reducer = persistReducer(
  { storage, key: "filter" },
  (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
      case actionTypes.UpdateFilter:
        return payload;
      case actionTypes.ClearFilter:
        return initialState;
      default:
        return state;
    }
  }
);

export const actions = {
  updateFilter: payload => ({ type: actionTypes.UpdateFilter, payload: payload }),
  clearFilter: payload => ({ type: actionTypes.ClearFilter, payload: payload })
};
